<template>
  <div class="page-wrapper">
    <component v-bind:is="headerComponent"></component>
    <div class="contacts-content">
      <div class="container">
        <h1>Want to contact us</h1>
        <form v-on:submit.prevent="handleSubmit" class="form">
          <div class="input-group">
            <!--            <label class="label" for="email">
                          {{$t('yourEmailAddressText')}}
                          <span class="red">*</span>
                        </label>-->
            <input
                name="email"
                class="input"
                type="text"
                id="email"
                v-model="email"
                aria-required="true"
                placeholder="Your email address *"
            >
            <div :class="errEmail" id="email-err" class="notification notification-error notification-inline" style="padding:10px 15px 35px 15px;">
              {{inputErr.email}}
            </div>
          </div>

          <div class="input-group">
            <!--            <label class="label" for="subject">
                          {{$t('subjectText')}}
                          <span class="red">*</span>
                        </label>-->
            <input
                v-on:keyup.prevent="searchArticles"
                id="subject"
                type="text"
                class="input"
                v-model="subject"
                aria-required="true"
                placeholder="Subject *"
            >
            <div id="subject-err" :class="errSubject" class="notification notification-error notification-inline" style="padding:10px 15px 35px 15px;">
              {{inputErr.subject}}
            </div>
          </div>
          <div class="input-group">
            <!--            <label class="label" for="articles">-->
            <!--              {{$t('helpWithText')}}-->
            <!--              <span class="red">*</span>-->
            <!--            </label>-->
            <select v-model="article" id="articles" class="input select">
              <option selected disabled value="">What do you need help with? *</option>
              <option :value="$store.getters.flowObject.variables.popularQuestions[2]">{{$t('popQues4')}}</option>
              <option :value="$store.getters.flowObject.variables.popularQuestions[0]">{{$t('popQues1')}}</option>
              <option :value="$store.getters.flowObject.variables.popularQuestions[1]">{{$t('popQues2')}}</option>
              <option value="none">{{$t('noValueArticleSelectText')}}</option>
            </select>
          </div>
          <transition name="fade" v-if="article">
            <div class="input-group">
              <Article :articleIdProp="article"/>
            </div>
          </transition>
          <div class="input-group">
            <!--            <label class="label" for="description">
                          {{$t('requestDescriptionText')}}
                          <span class="red">*</span>
                        </label>-->
            <textarea
                name="description"
                id="description"
                class="textarea"
                aria-required="true"
                v-model="description"
                aria-describedby="request_description_hint"
                placeholder="Description *"
            >
            </textarea>
            <div :class="errDescription" id="description-err" class="notification notification-error notification-inline" style="padding:10px 15px 35px 15px;">
              {{inputErr.description}}
            </div>
          </div>

          <div class="input-group">
            <p class="input-group__fineprint">{{$t('requestFormPlaceholder')}}</p>
          </div>

          <div class="input-group">
            <label class="label" for="file-upload">{{$t('requestAttachmentsText')}}</label>
            <component v-bind:is="fileUploadComponent"></component>
          </div>

          <div class="input-group input-group--btns">
            <button
                :disabled="loading"
                id="submit"
                @click="trackPageClick('submit_request_attempt')"
                class="btn"
                type="submit"
            >{{$t('requestSubmitText')}}</button>
          </div>
          <div class="input-group input-group--btns input-group--btns-recaptcha">
            <button
                style="visibility: hidden;"
                id="recaptcha"
                class="g-recaptcha"
                v-bind="{
              'data-sitekey':`${siteKey}`,
              'data-callback': `myRecaptchaHandler`,
              'data-badge': 'inline'
              }"
            ></button>
          </div>
          <div
              id="recaptcha-error"
              class="notification notification-error notification-inline"
              style="padding: 10px 15px 35px;color: red;display: none;"
          >{{errorMessage}}</div>
        </form>
      </div>
    </div>
    <component v-bind:is="footerComponent"></component>
  </div>
</template>

<script>
import VueRecaptcha from 'vue-recaptcha';
import Article from '@/components/article/zen_no_title';

import {
  searchLocalArticles,
  formatArticleTitles,
  getComponent,
  handleRequestSubmit,
  trackPageView,
  trackPageClick,
  getPageHash
} from '@/utils/common';

export default {
  name: 'requests',
  data() {
    return {
      email: '',
      description: '',
      subject: '',
      article: '',
      errorMessage: '',
      queryResults: [],
      siteKey: process.env.RECAPTCHA_SITEKEY,
      inputErr: {
        email: '',
        description: '',
        subject: ''
      },
      loading: null,
      errDisplay: {
        email: false,
        description: false,
        subject: false
      }
    };
  },
  created() {
    trackPageView('submit_request');
  },
  mounted() {
    window.grecaptcha.render('recaptcha');
    // the handler for the captcha is defined on a property therefore it wont have access to this scope
    window.myRecaptchaHandler = this.recaptchaSucces;
  },
  metaInfo() {
    return {
      titleTemplate: `${this.$t('requestTitle')} - %s `
    };
  },
  components: { VueRecaptcha, Article },
  computed: {
    headerComponent() {
      return getComponent(this.$store.getters.flowObject, 'header');
    },
    articleComponent() {
      return getComponent(this.$store.getters.flowObject, 'article_no_title');
    },
    footerComponent() {
      return getComponent(this.$store.getters.flowObject, 'footer');
    },
    fileUploadComponent() {
      return getComponent(this.$store.getters.flowObject, 'fileUpload');
    },
    errEmail() {
      return {
        'hide-err': !this.errDisplay.email,
        'show-err': this.errDisplay.email
      };
    },
    errDescription() {
      return {
        'hide-err': !this.errDisplay.description,
        'show-err': this.errDisplay.description
      };
    },
    errSubject() {
      return {
        'hide-err': !this.errDisplay.subject,
        'show-err': this.errDisplay.subject
      };
    }
  },
  methods: {
    getHash(article) {
      return getPageHash(article);
    },
    recaptchaSucces() {
      this.clearErrors();
      this.loading = true
      handleRequestSubmit(this.email, this.subject, this.description, this.article).then(response => {
        this.email = '';
        this.subject = '';
        this.description = '';
        document.getElementById('recaptcha-error').style.display = 'none';
        this.loading = false;
        this.$router.push({ path: 'home', query: { request: 'success' } });
      }).catch(error => {
        this.loading = false;
        if (error.response && error.response.data.message === 'reCaptcha authentication failed') {
          this.displayGeneralError(this.$t('requestCaptchaFailed'));
          window.grecaptcha.reset();
        } else if (error.message === 'file upload still in progress') {
          this.displayGeneralError(this.$t('requestUploadInProgress'));
        } else if ((error.response && error.response.data.message === 'invalid email address') || error === 'invalid email address') {
          this.inputErr.email = this.$t('invalidEmail');
          this.errDisplay.email = true;
          document.getElementById('email').focus();
        } else if (error.message === 'missing fields') {
          error.fields.forEach(field => {
            this.inputErr[field] = this.$t(`zendesk-missing-${field}`);
            this.errDisplay[field] = true;
            document.getElementById(`${field}`).focus();
          });
        } else {
          this.displayGeneralError(this.$t('requestErrorMessage'));
        }
      });
    },
    displayGeneralError(message) {
      let errorEl = document.getElementById('recaptcha-error');
      this.errorMessage = message;
      errorEl.style.display = 'block';
      errorEl.focus();
    },
    handleSubmit() {
      if (window.grecaptcha.getResponse() === '') {
        return window.grecaptcha.execute();
      }
      this.recaptchaSucces();
    },
    trackPageClick(clickName) {
      return trackPageClick(clickName);
    },
    searchArticles() {
      if (this.subject && this.subject.length > 2) {
        let query = this.subject.replace(/\+/g, ' ');
        const queries = query.split(' ').map(query => new RegExp(`(${query})`, 'i'));
        this.articles = searchLocalArticles(queries);
        const suggestions = formatArticleTitles(this.articles, query);
        this.queryResults = suggestions;
      } else if (this.subject.length < 3) {
        this.queryResults = [];
      }
    },
    clearErrors() {
      document.getElementById('recaptcha-error').style.display = 'none';
      this.errDisplay = {
        email: false,
        description: false,
        subject: false
      };
      this.inputErr = {
        email: '',
        description: '',
        subject: ''
      };
    }
  }
};
</script>
<!-- Add "scoped" attribute to limit CSS to this component only -->
<style lang="scss" scoped="true">
@import '@/styles/zeus-design.scss';
.contacts-content {
  padding: 80px 0 30px;
  .container {
    max-width: 470px;
    margin: 0 auto;
  }
  h1 {
    color: #333333;
    text-align: center;
    font-size: 40px;
    font-weight: 300;
    margin: 0 0 50px;
    font-family: "Segoe UI", Arial, sans-serif;
  }
}

.form {
  position: relative;
}
.input-group {
  margin-bottom: 30px;

}
.input-group--btns {
  margin: 0 0 30px;
  text-align: center;
  &.input-group--btns-recaptcha {
    display: flex;
    justify-content: center;
    > div {
      text-align: left;
    }
  }
}
.label {
  display: block;
  font-size: 18px;
  color: #444;
  margin-bottom: 20px;
}
.textarea,
.input {
  box-shadow: 0px 4px 40px rgba(0, 0, 0, 0.03);
  max-width: 100%;
  height: 40px;
  border-radius: 30px;
  box-sizing: border-box;
  outline: none;
  transition: border 0.12s ease-in-out;
  font-size: 14px;
  background: #fff;
  border: 1px solid #fff;
  padding: 10px 30px;
  width: 100%;
  color: #333;
  font-family: "Segoe UI", Arial, sans-serif;
  font-weight: 300;
  &:focus {
    border: 1px solid #0072ef;
  }
  &::placeholder {
    color: #333;
    opacity: 1;
  }
}
.textarea {
  resize: none;
  min-height: 180px;
  overflow: auto;
}
.select {
  appearance: none;
  background-color: #fff;
  background-image: url("data:image/svg+xml,%3csvg xmlns='http://www.w3.org/2000/svg' viewBox='0 0 16 16'%3e%3cpath fill='none' stroke='%23343a40' stroke-linecap='round' stroke-linejoin='round' stroke-width='2' d='M2 5l6 6 6-6'/%3e%3c/svg%3e");
  background-repeat: no-repeat;
  background-position: right .75rem center;
  background-size: 16px 12px;
  color: #333;
  &:hover {
    cursor: pointer;
  }
}
.input-group__fineprint {
  color: #333;
  font-size: 14px;
  margin: 5px 0;
  font-weight: 300;
}

.searchbox {
  font-size: 13px;
  color: #676767;
  font-family: Roboto, Helvetica, Arial, sans-serif;
}
.sug-label {
  border-bottom: 1px solid #ddd;
  display: block;
  padding-bottom: 5px;
}

ul {
  list-style: none;
  padding-left: 0px;
}
.suggestion-list li {
  padding: 10px 0;
  box-sizing: border-box;
  a {
    text-decoration: none;
    color: #0072ef;
    background-color: transparent;
  }
}
.fade-enter-active{
  transition: opacity 0.7s;
}
.fade-leave-active {
  transition: opacity 0.1s;
}
.fade-enter, .fade-leave-to /* .fade-leave-active below version 2.1.8 */ {
  opacity: 0;
}

.notification-inline.notification-error {
  background-color: #f4dfde;
  border: 1px solid #e03b30;
  color: #e03b30;
}
.notification {
  border: 1px solid;
  display: table;
  font-family: sans-serif;
  font-size: 12px;
  padding: 10px 15px 15px 15px !important;
  margin: 0px 0px 30px 0px !important;
  transition: height .2s;
  width: 100%;
  color: #555;
}
.notification-inline {
  border-radius: 4px;
  font-weight: 100;
  line-height: 14px;
  margin-top: 5px;
  padding: 5px;
  position: relative;
  text-align: left;
  vertical-align: middle;
}
.notification-error {
  background: #ffeded;
}
.notification-inline.notification-error::before {
  border-radius: 50%;
  border: 1px solid #e03b30;
  color: #e03b30;
  content: "!";
  display: inline-block;
  font-family: sans-serif;
  font-size: 8px;
  font-weight: normal;
  height: 12px;
  line-height: 12px;
  margin: -2px 5px 0 0;
  text-align: center;
  vertical-align: middle;
  width: 12px;
}
.flc::first-letter {
  text-transform: uppercase; /* change first letter to uppercase */
}
.show-err {
  display: block;
}
.hide-err {
  display: none;
}
@media (max-width: 768px) {
  .contacts-content {
    padding: 50px 0 20px;
    h1 {
      font-size: 30px;
      margin: 0 0 30px;
    }
  }
}
</style>
